import React, { useContext } from "react";
import { Text, LegacyCard as Card, Layout, Collapsible, BlockStack, RadioButton } from "@shopify/polaris";
import { Editor } from "@tinymce/tinymce-react";

// import hoc
import { withErrorBoundary, withFeature } from "lib/hoc";

// import constant
import constant from "lib/constant/constant";
import { baseHelper } from "lib/helpers";

// import context
import { PrivateContext } from "lib/context";
import { BrandingContext } from "app/setup/modules/operator/features/branding/context/context";

const Footer = () => {
  const { cms = () => {}, currentUser } = useContext(PrivateContext);
  const { updatedAt = "" } = currentUser || {};
  const { IS_DEFAULT, FOOTER, CONTENT } = constant;
  const {
    // learnMore
    page,
  } = useContext(BrandingContext);
  const { footer, handleChange, handleTiny } = page;

  const footerList = [
    {
      label: cms("section.footerText.label.default"),
      value: true,
      id: "defaultFooter",
    },
    {
      label: cms("section.footerText.label.customized"),
      value: false,
      id: "customFooter",
    },
  ];

  const renderList = () => {
    return footerList.map((list) => (
      <RadioButton
        label={list.label}
        checked={footer.isDefault === list.value}
        id={list.id}
        key={list.id}
        name="footer"
        onChange={() => handleChange(IS_DEFAULT, list.value, FOOTER)}
      />
    ));
  };

  return (
    <Collapsible open>
      <Layout.AnnotatedSection
        title={cms("section.footerText.title")}
        description={cms("section.footerText.description")}
      >
        <Card
          title={[
            cms("section.footerText.title"),
            updatedAt && (
              <Text as="span" tone="subdued">
                <Text variant="bodySm" as="p">{`${baseHelper.lastUpdateDate(updatedAt)}`}</Text>
              </Text>
            ),
          ]}
          // actions={[{ content: "Learn more", onAction: () => learnMore(cms("section.footerText.title"), "TODO: ") }]}
        >
          <Card.Section>
            <BlockStack gap="2">{cms("section.footerText.description")}</BlockStack>
            <br />
            <BlockStack>{renderList()}</BlockStack>
            <br />
            <Collapsible open={!footer.isDefault} id="custom-footer-collapsible">
              <BlockStack gap="10">
                <Editor
                  id="footerCustomText"
                  textareaName="footerDescription"
                  value={footer.content}
                  onEditorChange={(value) => handleTiny(CONTENT, value, FOOTER)}
                  init={{
                    menubar: true,
                    plugins: ["link"],
                    toolbar: "undo redo | bold italic | alignleft aligncenter alignright | code",
                  }}
                />
              </BlockStack>
            </Collapsible>
          </Card.Section>
        </Card>
      </Layout.AnnotatedSection>
    </Collapsible>
  );
};

export default withFeature(withErrorBoundary(Footer), {
  feature: constant.STANDARD_BRANDING,
});
